var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.guideData && _vm.activeComponent)?_c(_vm.activeComponent,{tag:"component",attrs:{"guideData":_vm.guideData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }